import { inject, Injectable } from "@angular/core";
import { PlatformLocation } from "@angular/common";
import { OfflineModalComponent } from "../components/offline-modal/offline-modal.component";
import { UserService } from "./user.service";
import { Aml5ModalComponent } from "../components/aml5-modal/aml5-modal.component";
import { AccountService } from "../../account/services/account.service";
import { WithdrawalLockComponent } from "../components/withdrawal-lock/withdrawal-lock.component";
import { SendModalComponent } from "../components/step-summary/sending-modal/send-modal/send-modal.component";
import { FiatWithdrawalModalComponent } from "../components/step-summary/fiat-transactions/fiat-withdraw-modal/fiat-withdraw-modal.component";
import { LegalAcceptanceComponent } from "../components/legal-acceptance-modal/legal-acceptance.component";
import { CanCreate, Modal, ModalOptions, ModalService } from "@core-services/modal.service";
import { TermsAndConditionsService } from "@modules/shared/terms-and-conditions/services/terms-and-conditions.service";

@Injectable({
	providedIn: "root"
})
export class ModalGuardService implements CanCreate {
	private termsAndConditionsService: TermsAndConditionsService = inject(TermsAndConditionsService);
	public whiteListedLockModals = [LegalAcceptanceComponent, WithdrawalLockComponent, Aml5ModalComponent];
	public blackListedModalsAfterPasswordReset = [SendModalComponent, FiatWithdrawalModalComponent];
	private isDynamicTermsAndConditionsActive: boolean = false;

	public constructor(
		private accountService: AccountService,
		private userService: UserService
	) {
		this.termsAndConditionsService.isDynamictermAndConditionActive$.subscribe((isActive) => {
			this.isDynamicTermsAndConditionsActive = isActive;
		});
	}

	public static guardedModalServiceFactory(location: PlatformLocation, guard: ModalGuardService): ModalService {
		return new ModalService(location, guard);
	}
	// TODO: eslint fix
	/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
	public canCreate(component: any, inputs: any, options: ModalOptions): boolean {
		if (
			(this.accountService.account == null && component === OfflineModalComponent) ||
			component === Aml5ModalComponent
		) {
			return true;
		}
		return (
			this.whiteListedLockModals.some((modal) => modal === component) ||
			// Privacy policy check
			// If we try to create a modal before the account is created in account.service.ts,
			// it will throw an error. Checking if account is null prevents that.
			((this.accountService.account === null ||
				this.accountService.acceptedTerms() ||
				this.isDynamicTermsAndConditionsActive) &&
				// Password reset check
				(this.userService.user.isWithdrawTransactionAllowed() ||
					!this.blackListedModalsAfterPasswordReset.some((modal) => modal === component)))
		);
	}

	public createLockModal(modalService: ModalService): Modal {
		if (this.accountService.account == null) {
			return modalService.create(OfflineModalComponent);
		}
		if (!this.accountService.acceptedTerms() && !this.isDynamicTermsAndConditionsActive) {
			// This code seems dead as this.accountService.acceptedTerms always returns true
			// Needs future investigation
			return modalService.create(LegalAcceptanceComponent);
		}
		return modalService.create(WithdrawalLockComponent);
	}
}
